<template>
    <div class="Matchinglist">
        <!-- 海逊商场 -->
        <div>
            <el-input v-model="input" style="width: 25%;" placeholder="请输入搜索内容"></el-input>
            <el-button type="primary" class="search" style="margin-left:10px" @click="search">搜索</el-button>
            <el-button type="primary" class="search" style="margin-left:10px" @click="reset">重置</el-button>
        </div>
        <div class="margin-top1">
            <el-col :span="4" v-for="(o,index) in this.tableData" :key="index" style="margin-left:20px;">
                <el-card :body-style="{ padding: '0px' }">
                <img :src="o.images" class="image" @click="Edit(o)">
                <div class="box">
                    <div class="bottom clearfix">
                        <div>{{o.productFullName}}</div>
                        <div>库存数量：{{o.actualCount}}</div>
                    </div>

                    <div class="bottom clearfix">
                        <div>现价：{{o.currentPrice}}</div>
                        <div>原价：{{o.originalPrice}}</div>
                    </div>
                </div>
                </el-card>
            </el-col>
        </div>

        <el-dialog title="商品信息" :visible.sync="dialogVisible" width="40%">
            <div class="inbox">
                <el-image 
                    style="width: 270px; height: 270px"
                    :src="this.mainData.images" 
                    :preview-src-list="this.mainData.imagesList">
                </el-image>
                <div style="margin-left:20px;line-height: 50px;">
                    <h2>商品全称：{{this.mainData.productFullName}}</h2>
                    <h3>原价：￥{{this.mainData.originalPrice}}</h3>
                    <h3>现价：￥{{this.mainData.currentPrice}}</h3>
                    <p>库存数量：{{this.mainData.actualCount}}</p>
                    <p>商品描述：{{this.mainData.productDescription}}</p>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Matchinglist",
    data() {
        return {
            input:"",
            tableData:[],
            dialogVisible:false,
            mainData:"",
        };
    },
    created(){
        this.search()
    },
    methods: {
        search(){
                var obj = {
                    page:1,
                    size:1000,
                    searchString:this.input
                };
                ajaxPost(Baseurl + "inventoryController/selectOnLineInventorysList",obj).then(res => {
                    if(res.data.code == 200){
                        this.tableData = res.data.data.list
                    }
                });
        },
        reset(){
            this.input = ""
            this.search()
        },
        Edit(val){
            console.log(val)
            this.mainData = val
            this.dialogVisible = true
        }
    }
};
</script>
<style lang="scss">
.Matchinglist {
    width: 98%;
}
  
  .bottom {
    margin-top: 13px;
    line-height: 25px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 270px;
    height: 270px;
    display: block;
    cursor: pointer;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
  .box{
      padding: 14px;
      display: flex;
      justify-content: space-between;
  }
  .inbox{
      display: flex;
      justify-content: left;
  }
</style>
